<div class="col" *ngIf="isLoaded">
    <div class="card-header justify-content-between d-flex align-items-center">
        <!-- <div class="card-title mb-auto" data-bs-toggle="tooltip"
            [title]="isEdit ? ('EDIT_ROLE' | translate) : ('ADD_ROLE' | translate)">
            {{ isEdit ? ('EDIT_ROLE' | translate) : ('ADD_ROLE' | translate) }}
        </div> -->
        <div class="card-title mb-auto" data-bs-toggle="tooltip"
        [title]="isEdit ? ('EDIT_ROLE' | translate) : ('ADD_ROLE' | translate)"></div>
        
        <button type="submit" class="btn btn-primary" (click)="onSubmit()">
            <i class="fa fa-save"></i> 
             {{ isEdit ? ('UPDATE' | translate) : ('SAVE' | translate) }} 
            
        </button>

    </div>
    <div class="card-body">
        <form [formGroup]="roleForm">
            <!-- Role Name Input -->
            <div class="mb-4 col-6">
                <label for="roleName" class="form-label fw-bold required-label">{{ 'ROLE_NAME' | translate }}
                    <span class="text-danger" aria-hidden="true">*</span>
                    <span class="sr-only">(required)</span>
                </label>
                <input type="text" id="roleName" formControlName="roleName" class="form-control"
                    placeholder="{{ 'ENTER_ROLE_NAME' | translate }}">

                <div *ngIf="roleForm.get('roleName')?.touched && roleForm.get('roleName')?.invalid" class="text-danger">
                    <div *ngIf="roleForm.get('roleName')?.errors?.['required']">{{ 'ROLENAME_REQUIRED' | translate }}
                    </div>
                    <div *ngIf="roleForm.get('roleName')?.errors?.['maxlength']">
                        {{ 'ROLE_MAXLENGTH' | translate: { maxLength: ValidationConstants.MAX_NAME_LENGTH } }}
                    </div>
                </div>
            </div>
            <div class="checkbox">
                <input type="checkbox" class="form-check-input" id="selectAllPermissions"
                    (change)="toggleSelectAll($event)">
                <label class="form-check-label" for="selectAllPermissions">
                    {{ 'SELECT_ALL' | translate }}
                </label>
            </div>
            <div ngbAccordion [closeOthers]="false" >
                <div *ngFor="let page of pages; let i = index" ngbAccordionItem [collapsed]="!openedAccordions[i]">
                    <h2 ngbAccordionHeader>
                        <button ngbAccordionButton (click)="toggleAccordion(i)" style="color: black; font-size: large;">
                            {{ page.name }}
                        </button>
                    </h2>
                    <div ngbAccordionCollapse>
                        <div ngbAccordionBody>
                            <ng-template>
                                <div class="row">
                                    <!-- Checkboxes for Permissions within the Accordion Section -->
                                    <div *ngFor="let action of page.actions" class="col-md-6 mb-2">
                                        <div class="checkbox">
                                            <input type="checkbox"
                                                [formControlName]="getPermissionControlName(action.code, action.id)"
                                                class="form-check-input" [id]="'permission_' + action.id">
                                            <label class="form-check-label ms-2" [for]="'permission_' + action.id">
                                                {{ action.name }}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>